import React from "react";

function UpdatePopup({ isOpen, onClose, onUpdate }) {
  if (!isOpen) return null;

  const popupStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  };

  const boxStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    textAlign: "center",
    width: "80%",
    maxWidth: "320px",
  };

  const buttonStyle = {
    margin: "10px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  };

  return (
    <div style={popupStyle}>
      <div style={boxStyle}>
        <h3>Please Update App</h3>
        <p>A new version of the app is available.</p>
      {/* <h3>Scheduled Maintenance</h3>
    <p>
      Our servers are currently undergoing an update to improve performance and reliability.
      <br />
      <b>Estimated downtime: 30 minutes.</b>
      <br />
      We’ll be back shortly — thank you for your patience!
    </p> */}
        <div>
          <button
            style={{ ...buttonStyle, background: "#007bff", color: "#fff" }}
            onClick={onUpdate}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdatePopup;
